import CustomAxios from "..";

export const uploadWorkout = async (formData, fileName) => {
  try {
    return await CustomAxios.post(
      `/plans/json?fileName=${encodeURIComponent(fileName)}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  } catch (error) {
    console.error("Error uploading plan:", error);
    throw error;
  }
};

export const getWorkoutPlanById = async (id) => {
  try {
    const response = await CustomAxios.get(`/plans/${id}`);

    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const deleteWorkoutPlanById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/plans/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

export const getExerciseData = async (params={}) => {
  try {
    const response = await CustomAxios.get(`/plans`,{params});
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPlansByTag = async (planTag) => {
  try {
    const response = await CustomAxios.get(
      `/plans/workouts/tag/${encodeURIComponent(planTag)}`
    );
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching plans with tag "${planTag}":`,
      error.response || error
    );
    throw new Error("Failed to retrieve the plans by tag. Please try again.");
  }
};
